import type { ResourceItemProps } from '@shopify/polaris';

import { Button } from '@shopify/polaris';

interface IProps {
  actions?: ResourceItemProps['shortcutActions'];
}

/**
 * Shortcut actions of a pick-resource row on mobile. They live at the row level (not in the content
 * column) so they span the full width under the thumbnail, and they stay visible since mobile has
 * no hover state.
 */
export const CampaignPickItemMobileActions: React.FC<IProps> = ({ actions }) => {
  if (!actions?.length) return null;

  return (
    <div className="flex flex-col gap-2 px-3 pb-3 md:hidden">
      {actions.map((action) => (
        <Button
          key={String(action.content)}
          variant="secondary"
          fullWidth
          onClick={action.onAction}
        >
          {action.content}
        </Button>
      ))}
    </div>
  );
};
